import { ErrorOutlineRounded } from '@mui/icons-material';
import { ArrowUpwardRounded } from '@mui/icons-material';
import {
    Button,
    Card,
    CardContent,
    Chip,
    Grid,
    Stack,
    Typography,
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useGetListDataQuery } from '../../api/apiSlice';
import ExternalScreen from '../../components/fragments/ExternalScreen';
import ListLoading from '../../components/fragments/ListLoading';
import { useNavigate } from 'react-router';

const TransactionItem = ({ status, amount, type, dated }) => {
    return (
        <ListItem sx={{ px: 0 }}>
            <ListItemIcon sx={{ minWidth: 40 }}>
                {status == 'undetermined' ? (
                    <ErrorOutlineRounded color="error" />
                ) : (
                    <ArrowUpwardRounded color="success" />
                )}
            </ListItemIcon>
            <ListItemText
                primary={
                    <>
                        {type} <Chip size="small" label={status} />
                    </>
                }
                secondary={moment(dated).format('MMM DD YY HH:MM')}
            />
            <Stack direction="row" alignItems="end">
                <Typography variant="body2">KSH </Typography>
                <Typography variant="body2">{amount}</Typography>
            </Stack>
        </ListItem>
    );
};

export default function MyWallet() {
    const navigate = useNavigate();

    const { data: walletData, isFetching } = useGetListDataQuery({
        list: '/wallet/balance',
    });

    const { data: transactionsData, isLoading: isTransactionsLoading } =
        useGetListDataQuery({
            list: '/wallet',
        });

    return (
        <ExternalScreen title="My Wallet" authPass>
            <Grid item xs={12}>
                <Card variant="outlined" sx={{ width: '100%' }}>
                    <CardContent sx={{ p: 1.5 }}>
                        <Stack
                            direction="row"
                            justifyContent="space-around"
                            sx={{ mx: 0.5, my: 1 }}
                        >
                            <Box>
                                <Typography variant="h5">
                                    {isFetching
                                        ? '0'
                                        : walletData?.account?.pending}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    PENDING
                                </Typography>
                            </Box>
                            <Box>
                                <Stack direction="row" alignItems="end">
                                    <Typography variant="body2">KSH</Typography>
                                    <Typography variant="h5">
                                        {isFetching
                                            ? '0'
                                            : walletData?.account?.balance}
                                    </Typography>
                                </Stack>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    BALANCE
                                </Typography>
                            </Box>
                        </Stack>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => navigate('/minister-signup?page=1')}
                        >
                            Add Funds
                        </Button>
                    </CardContent>
                </Card>
            </Grid>
            <Grid sx={{ mt: 2 }} item xs={12}>
                <Typography sx={{ mx: 0.5 }} variant="h6">
                    Transactions
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <List sx={{ width: '100%' }}>
                    {isTransactionsLoading && <ListLoading />}
                    {!isTransactionsLoading &&
                        transactionsData?.data?.map((transaction) => (
                            <TransactionItem
                                key={transaction?.id}
                                {...transaction}
                            />
                        ))}
                </List>
            </Grid>
        </ExternalScreen>
    );
}
